const toggledSidebarReducer = (toggled_sidebar = false, action) => {
    switch (action.type) {
        case "SET_TOGGLED_SIDEBAR":
            return action.payload;
        default:
            return toggled_sidebar;
    }
};

export default toggledSidebarReducer;